<div class="nav-dots">
  @for(dot of pages; track dot; let idx = $index;) {
  <div class="dot" (click)="scrollToPage(idx)" #dot></div>
  }
</div>
